// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"errorBoundary_errorContainer__UqKI7","reloadButton":"errorBoundary_reloadButton__ce3EO"};